import { CarSubmission } from "./CarSubmission";
export { CarSubmission };
export type { ICarSubmissionProps, IZoomDataLayerEvents, ILpPrediction } from "./CarSubmission";
